import {
  Component,
  EventEmitter,
  Input,
  OnChanges,
  Output,
} from '@angular/core';
import { DropdownItem } from '@frk/eds-components';

export interface GridFilterComponent {
  filterExchange: (value: string) => void;
  exchangeItems: DropdownItem[];
}

export interface GridFilterGroupHeaderParams {
  parentComponent: GridFilterComponent;
}

@Component({
  selector: 'ft-grid-filter-group-header',
  templateUrl: './grid-filter-group-header.component.html',
  styleUrls: ['./grid-filter-group-header.component.scss'],
})
export class GridFilterGroupHeaderComponent implements OnChanges {
  @Output() filterListData = new EventEmitter<[]>();
  @Input() params: GridFilterGroupHeaderParams;
  parentComponent: GridFilterComponent;

  exchangeItems: DropdownItem[];

  ngOnChanges() {
    if (this.params) {
      this.agInit(this.params);
    }
  }

  agInit(params: GridFilterGroupHeaderParams): void {
    this.parentComponent = params.parentComponent;
    this.exchangeItems = this.parentComponent.exchangeItems;
  }
}
